import {IHeaderAngularComp} from "ag-grid-angular";
import {IHeaderParams} from "ag-grid-community";
import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from "@angular/core";
import {HgHedgeMatrixComponent} from "../hg-hedge-matrix.component";
import {DetectMethodChanges} from "../../../utils";
import {parseColId} from "../hedge-matrix-col-id";

@Component({
    selector: 'ets-hedge-matrix-custom-header',
    template: `
      <div class="hege-name" [title]="this.hedgeName" (click)="this.onClick()" [style.color]="this.hedgeColor">
        <span *ngIf="this.underlyingDisplay" class="underlying-badge">{{this.underlyingDisplay}}</span>{{this.hedgeName}}
      </div>
    `,
    styles: [
        `
            .hege-name {
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .underlying-badge {
                font-size: 9px;
                font-weight: 700;
                color: #aaa;
                background: #333;
                border: 1px solid #555;
                border-radius: 3px;
                padding: 1px 4px;
                letter-spacing: 0.5px;
                white-space: nowrap;
                margin-right: 3px;
                vertical-align: middle;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HedgeMatrixCustomHeaderComponent implements IHeaderAngularComp {

    constructor(
        private _changeDetector: ChangeDetectorRef
    ) {
    }

    private _hedgeId: string;
    private _etsComponent: HgHedgeMatrixComponent

    get underlyingDisplay(): string {
        const hedge = this._etsComponent?.hedgeMatrixDataService?.getHedge(this._hedgeId);
        if (!hedge) { return undefined; }
        const baseUl = this._etsComponent.hedgeMatrixDataService.getPortfolioUnderlying();
        const hedgeUl = hedge.underlying;
        if (!hedgeUl || hedgeUl === baseUl) { return undefined; }
        return this._etsComponent.nonBaseUnderlyingSections
            ?.find(s => s.underlying === hedgeUl)?.displayName;
    }

    get hedgeName(): string {
        const hedge = this._etsComponent?.hedgeMatrixDataService?.getHedge(this._hedgeId);
        return hedge?.name ?? '';
    }

    get hedgeColor(): string | null {
        const hedge = this._etsComponent?.hedgeMatrixDataService?.getHedge(this._hedgeId);
        return hedge?.color || null;
    }

    @DetectMethodChanges()
    agInit(params: IHeaderParams): void {
        // hedgeId derived from colId (per-column immutable). ag-Grid 24 aliases
        // headerComponentParams.context.hedge across hedge columns during setColumnDefs,
        // so context.hedge is not a trustworthy per-column identity source.
        const colId = (params as any)?.column?.getColId?.() ?? '';
        this._hedgeId = parseColId(colId)?.hedgeId ?? '';
        this._etsComponent = params.context?.comp ?? params.context?.etsComponent;
    }

    @DetectMethodChanges()
    refresh(params: IHeaderParams): boolean {
        const colId = (params as any)?.column?.getColId?.() ?? '';
        this._hedgeId = parseColId(colId)?.hedgeId ?? '';
        this._etsComponent = params.context?.comp ?? params.context?.etsComponent;
        return true;
    }

    async onClick() {
        if (!this._etsComponent.isTextFormatCopyAvailable()) {
            return;
        }
        await this._etsComponent.onHedgeHeaderClicked(this._hedgeId);
    }

}